import { yupResolver } from "@hookform/resolvers/yup";
import { cn } from "@omni/utils/styles";
import { FormProvider, SubmitHandler } from "react-hook-form";
import * as yup from "yup";

import { TextField } from "@/components/Form/RHF/FormFields/TextField/Textfield.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { FormInfoProvider } from "@/utils/forms/formInfo.provider";
import * as userRHFValidationRules from "@/utils/validation/schemas/user.RHF";
import "./forgotPasswordForm.scss";

import { useOmniForm } from "@/components/Form/RHF/Utils/useOmniForm";

export const FORM_ID = "checkoutForgotPasswordForm";

const ForgotPasswordFormValidationSchema = yup
    .object({
        email: userRHFValidationRules.emailWithNB
    })
    .required();

type FormValues = yup.InferType<typeof ForgotPasswordFormValidationSchema>;

type CheckoutForgotPasswordFormComponentProps = {
    className?: string;
    notification: string;
    onSubmit: (email: string) => void;
};

const CheckoutForgotPasswordFormComponent = ({
    className,
    notification,
    onSubmit
}: CheckoutForgotPasswordFormComponentProps) => {
    const { t } = useGranite();

    const methods = useOmniForm({
        mode: "onBlur",
        reValidateMode: "onBlur",
        defaultValues: {
            email: ""
        },
        resolver: yupResolver(ForgotPasswordFormValidationSchema)
    });

    const handleSubmit: SubmitHandler<FormValues> = async ({ email }) => {
        onSubmit(email);
    };

    return (
        <div className={cn("forgot-password-form", className)}>
            <div>
                <p>{notification}</p>
            </div>
            <FormInfoProvider
                formId={FORM_ID}
                withNeverbounce={true}
            >
                {({ initialized }) => (
                    <FormProvider {...methods}>
                        <form
                            id={FORM_ID}
                            onSubmit={methods.handleSubmit(handleSubmit)}
                        >
                            <TextField<FormValues>
                                name={"email"}
                                label={t("general.form.email.label")}
                                required={true}
                                autoComplete={"email"}
                                placeholder={t(
                                    "general.form.email.placeholder"
                                )}
                                disabled={!initialized}
                            />
                        </form>
                    </FormProvider>
                )}
            </FormInfoProvider>
        </div>
    );
};

export { CheckoutForgotPasswordFormComponent };
